//main-cart-items.liquid (gift coupon redemption)
var domain;
var shopifyDomain = "https://" + window.location.hostname + "/";

if (window.location.hostname.toLowerCase() == "dev-jp-rituals.myshopify.com") {
  //TEST
  domain = "https://crm-test-jp.bluebellgroup.com/RTJPCONTEST/v1/api";
} else {
  //PROD
  domain = "https://crm-sg.bluebellgroup.com/v1/api";
}

function getStoreName(storeId, successCallback, errorCallback) {
	fetch(domain + "/Shopify/StoreName?store_id=" + storeId, {
		method: 'GET',
		headers: {
			"bb-Shopify-Domain": shopifyDomain
		},
	})
    .then(response => {
      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
      return response.text();
    })
    .then(text => {
        successCallback(text);
    })
    .catch(err => {
        console.error(err);
        errorCallback(err);
    });
}